import React from 'react';
import { Modal } from './Modal';
import { stackApp } from '../../stackApp';

export function AuthModal({ open, onClose }) {
  if (!open) return null;
  return (
    <Modal title="Sign In to Sync Saves" onClose={onClose}>
      <div style={{ padding: '8px 0 16px' }}>
        <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20, lineHeight: 1.6 }}>
          Sign in to back up your progress to the cloud and pick up where you left off on any device.
        </p>
        <button
          className="btn btn-primary"
          style={{ width: '100%', padding: '12px', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}
          onClick={() => stackApp && stackApp.signInWithOAuth('google')}
        >
          <svg width="18" height="18" viewBox="0 0 48 48">
            <path fill="#FFC107" d="M43.6 20H24v8h11.3C33.7 33.1 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C33.8 6.5 29.2 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-4z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 15.1 18.9 12 24 12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C33.8 6.5 29.2 4 24 4 16.3 4 9.7 8.4 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-1.9 13.5-5.1l-6.2-5.2C29.4 35.5 26.8 36 24 36c-5.2 0-9.6-2.9-11.3-7l-6.6 5.1C9.8 39.7 16.4 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20H24v8h11.3c-.8 2.3-2.3 4.2-4.3 5.5l6.2 5.2C41 35.3 44 30 44 24c0-1.3-.1-2.7-.4-4z"/>
          </svg>
          Continue with Google
        </button>
        <p style={{ fontSize: 11, color: 'var(--text-dim)', marginTop: 14, textAlign: 'center', lineHeight: 1.4 }}>
          Guest saves are stored locally. Signing in syncs them to the cloud.
        </p>
      </div>
    </Modal>
  );
}
